import api from './APIService';

class SocialService {
	getAll(userId) {
		return api.fetch({ method: 'get', path: '/participant/social/' + userId });
	}
	update(data) {
		return api.fetch({ method: 'put', path: '/participant/social/', data });
	}
	getSocialUsers(data) {
		return api.fetch({ method: 'post', path: '/participant/social/getSocialUsers', data });
	}
}

export default new SocialService();
